import { render, staticRenderFns } from "./recommendations.vue?vue&type=template&id=08c98bf0&scoped=true&"
import script from "./recommendations.vue?vue&type=script&lang=js&"
export * from "./recommendations.vue?vue&type=script&lang=js&"
import style0 from "./recommendations.vue?vue&type=style&index=0&id=08c98bf0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c98bf0",
  null
  
)

export default component.exports